import { commonRoutes } from '@/app/providers/router/routes';
import { AppLink } from '@/app/shared/ui/AppLink';

export const NotFoundPage = () => {
  return (
    <div className='flex min-h-[calc(100vh-230px)] flex-col items-center justify-center md:min-h-[calc(100vh-138px)]'>
      <h1 className='text-[72px] leading-tight font-medium text-gray-600'>404</h1>
      <p className='mt-3 text-center font-medium text-foreground'>Looks like there is nothing here</p>
      <AppLink
        to={commonRoutes.VAULTS}
        className='mt-6 flex w-fit rounded-md bg-gray-800 px-4 py-3 whitespace-nowrap text-foreground transition-all duration-300 ease-in-out hover:bg-elevated-card-hover'
      >
        Go back to Homepage
      </AppLink>
    </div>
  );
};
